<template>
  <div>
    <div v-if="type !== '0'">
      <img v-if="number >= 0 && number <= 25" :src="power1" alt="" />
      <img v-else-if="number > 25 && number <= 50" :src="power2" alt="" />
      <img v-else-if="number > 50 && number <= 75" :src="power3" alt="" />
      <img v-else-if="number > 75" :src="power4" alt="" />
    </div>
    <div v-else>
      <img v-if="number >= 0 && number <= 25" :src="cpower1" alt="" />
      <img v-else-if="number > 25 && number <= 50" :src="cpower2" alt="" />
      <img v-else-if="number > 50 && number <= 75" :src="cpower3" alt="" />
      <img v-else-if="number > 75" :src="cpower4" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      power1: require('../../static/img/power1.png'),
      power2: require('../../static/img/power2.png'),
      power3: require('../../static/img/power3.png'),
      power4: require('../../static/img/power4.png'),
      cpower1: require('../../static/img/cpower1.png'),
      cpower2: require('../../static/img/cpower2.png'),
      cpower3: require('../../static/img/cpower3.png'),
      cpower4: require('../../static/img/cpower4.png')
    }
  },
  props: ['number', 'type', 'state'],
  methods: {
  }
}
</script>

<style scoped lang="less">
	img {
		width: 100%;
		height: 100%;
	}
</style>



// WEBPACK FOOTER //
// src/components/RobotPower.vue